import classnames from 'classnames'
import React, { CSSProperties } from 'react'

import styles from './fillRangeItem.module.scss'

export interface FillRangeItemProps {
  title?: string
  fillPercentage: number
  minLabel: string
  maxLabel: string
  fillColor?: string
  border?: boolean
  rounded?: boolean
  className?: string
  progressBarClassName?: string
  fillBarClassName?: string
  fillBarStyle?: CSSProperties
}

const ProgressBar = (
  fillPercentage: number,
  fillColor: string,
  progressBarClassName?: string,
  fillBarClassName?: string,
  fillBarStyle?: CSSProperties,
) => {
  const progressbarStyles = {
    borderColor: fillColor,
  }
  const fillerStyles = {
    width: `${fillPercentage <= 100 ? fillPercentage : 100}%`,
    backgroundColor: fillColor,
    borderColor: fillColor,
    ...(fillBarStyle || {}),
  }
  return (
    <div className={`${styles.progressBar} progressBar ${progressBarClassName}`} style={progressbarStyles}>
      <div className={classnames(styles.progressFiller, fillBarClassName)} style={fillerStyles}></div>
    </div>
  )
}

export const FillRangeItem = ({
  className = '',
  fillColor = '#ffa273',
  border = false,
  rounded = false,
  ...props
}: FillRangeItemProps) => {
  const fillRangeItemWrapClasses = classnames(
    styles.fillRangeItemWrap,
    { [styles.border]: border },
    { [styles.rounded]: rounded },
    className,
  )
  const titleClasses = classnames(styles.rangeTitle, ' font-case--upper', 'fillRangeItemTitle')

  return (
    <div className={`${fillRangeItemWrapClasses} fillRangeItem`}>
      {props.title && <h6 className={titleClasses}>{props.title}</h6>}
      <div className={styles.rangeBar}>
        {ProgressBar(
          props.fillPercentage,
          fillColor ? fillColor : '',
          props.progressBarClassName,
          props.fillBarClassName,
          props.fillBarStyle,
        )}
        <div className="d-flex justify-content--space-between">
          <p className={styles.label}>{props.minLabel}</p>
          <p className={styles.label}>{props.maxLabel}</p>
        </div>
      </div>
    </div>
  )
}

export default FillRangeItem
